/**
 * CihazLisansService — CİHAZ bazlı lisans (kullanıcıdan bağımsız).
 * Her tarayıcı/cihaz benzersiz kimlik (localStorage) alır; admin o cihaza uygulama/alt-özellik atayabilir.
 * Erişim: kullanıcı izni VEYA cihaz izni (UygulamaErisimService birleştirir).
 * Kayıt: hareketler vt='FikoYT.sistem.cihaz_lisans' { cihazId, cihazAdi, uygulamalar[], uygulamaAltlari[], fiyatlar{} }.
 */
import { Injectable, inject } from '@angular/core';
import { FikoYTRequestService } from '@/src/app/shared/services/fikoyt-request.service';

const VT = 'FikoYT.sistem.cihaz_lisans';
const AGG = 'FikoYT.sistem.DB.hareketler.aggregate';
const EKLE = 'FikoYT.sistem.DB.hareketler.ekle';
const GUNCELLE = 'FikoYT.sistem.DB.hareketler.guncelle';

export interface ICihazLisans { cihazId: string; cihazAdi?: string; uygulamalar: string[]; uygulamaAltlari: string[]; fiyatlar?: Record<string, number>; }

@Injectable({ providedIn: 'root' })
export class CihazLisansService {
  private req = inject(FikoYTRequestService);

  /** Bu tarayıcının benzersiz cihaz kimliği (localStorage; yoksa üretir). */
  cihazId(): string {
    let id = '';
    try { id = localStorage.getItem('fiko_cihaz_id') || ''; } catch { }
    if (!id) {
      id = 'cihaz_' + Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
      try { localStorage.setItem('fiko_cihaz_id', id); } catch { }
    }
    return id;
  }

  /** Bu cihazın lisans kaydı (yoksa boş). */
  async buCihazLisans(): Promise<ICihazLisans> { return this.cihazLisans(this.cihazId()); }

  async cihazLisans(cihazId: string): Promise<ICihazLisans> {
    try {
      const r = await this.req.aggregate<any>(AGG, [{ $match: { vt: VT, cihazId, silindi: { $ne: true } } }, { $limit: 1 }]);
      const d = r?.[0];
      return { cihazId, cihazAdi: d?.cihazAdi || '', uygulamalar: d?.uygulamalar || [], uygulamaAltlari: d?.uygulamaAltlari || [], fiyatlar: d?.fiyatlar || {} };
    } catch { return { cihazId, uygulamalar: [], uygulamaAltlari: [], fiyatlar: {} }; }
  }

  /** Tüm cihaz lisans kayıtları (admin listesi). */
  async cihazListesi(): Promise<ICihazLisans[]> {
    try { return await this.req.aggregate<any>(AGG, [{ $match: { vt: VT, silindi: { $ne: true } } }, { $sort: { _id: -1 } }]); }
    catch { return []; }
  }

  /** Cihaz lisansını kaydet (upsert — varsa güncelle, yoksa ekle). */
  async kaydet(cihazId: string, cihazAdi: string, uygulamalar: string[], uygulamaAltlari: string[], fiyatlar: Record<string, number>): Promise<void> {
    const mevcut = await this.req.aggregate<any>(AGG, [{ $match: { vt: VT, cihazId } }, { $limit: 1 }]);
    const veri = { cihazAdi, uygulamalar, uygulamaAltlari, fiyatlar };
    if (mevcut?.[0]?._id) await this.req.guncelle(GUNCELLE, { _id: mevcut[0]._id }, { $set: veri });
    else await this.req.ekle(EKLE, { vt: VT, cihazId, ...veri, tarih: new Date() });
  }
}
